import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { reduxForm, Field, clearSubmitErrors, submit, Form } from "redux-form";
import { authorizationActionCreators } from "../../store/actions/authorization";
import { submitFormHandler } from "../../store/actions/formRoutines/paymentAuthorization";
import { FormTextField } from "../../components/fields";
import styles from "./style.module.css";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

class PaymentAuthorizationForm extends PureComponent {

  render() {
    const { handleSubmit, submitting, closeModal, open, submit2 } = this.props;
    return (
      <Form onSubmit={handleSubmit(submitFormHandler)}>
        <Dialog PaperProps={{ className: styles.container }} open={open} onClose={closeModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">
            <Typography variant="h5">
              Payment authorization
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Field name="firstName"
                       component={FormTextField}
                       variant="outlined"
                       fullWidth
                       label="First name"
                       disabled={submitting}
                />
              </Grid>
              <Grid item xs={12}>
                <Field name="lastName"
                       component={FormTextField}
                       variant="outlined"
                       fullWidth
                       label="Last name"
                       disabled={submitting}
                />
              </Grid>
              <Grid item xs={12}>
                <Field name="email"
                       component={FormTextField}
                       variant="outlined"
                       fullWidth
                       label="Email"
                       disabled={submitting}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <div className={styles.formButtonBlock}>
              <Button type='button'
                      variant='outlined'
                      onClick={closeModal}
                      disabled={submitting}
                      className={styles.formButtonCancel}
              >
                Back
              </Button>
              <Button type='submit'
                      color="primary"
                      variant='contained'
                      disabled={submitting}
                      onClick={submit2}
                      className={styles.formButtonSave}
              >
                Submit
              </Button>
            </div>
          </DialogActions>
        </Dialog>
      </Form>
    );
  }
}

const InitializeFromStateForm = reduxForm({
  form: "paymentAuthorization",
  onChange: (values, dispatch, props) => {
    if (props.error) dispatch(clearSubmitErrors("paymentAuthorization"));
  },

})(PaymentAuthorizationForm);

const mapStateToProps = (state) => {
  return {
    open: state.authorization.showPaymentAuthorizedModal,
  };
};


export default connect(mapStateToProps, (dispatch) => {
  return ({
    closeModal: () => {
      dispatch(authorizationActionCreators.handlePaymentAuthorizedModal());
    },
    submit2: () => {
      dispatch(submit("paymentAuthorization"));
    },
  });
})(InitializeFromStateForm);

